import React from 'react';
import Box from '@mui/material/Box';
import {Input} from '@practicegenius/pg-ui/src/base/Material/components/Input';
import {TellUsMoreScreenType} from '@practicegenius/register-account/src/screens/TellUsMore';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import {
  AccountRelationship,
  RegistrationReason,
} from '@practicegenius/register-account/src/data/types';
import FormHelperText from '@mui/material/FormHelperText';
import {ProgressScreen} from '../../../components/screens/BaseScreen';
import {loginBottomText} from '../components/layout';

export const TellUsMore: TellUsMoreScreenType = props => (
  <form onSubmit={props.onFormSubmit}>
    <ProgressScreen
      helmetTitle={props.lang.pageTitle}
      headerTitle={props.lang.headerTitle}
      title={props.lang.title}
      instructions={props.lang.instructions}
      progress={props.progress}
      actionButtons={[
        props.actionButtons.primary,
        props.actionButtons.secondary,
      ]}
      cancelProps={{href: '/'}}
      bottomText={loginBottomText}
    >
      <Box sx={{display: 'flex', flexDirection: 'column', gap: 3}}>
        <FormControl fullWidth>
          <InputLabel id="relationship-label">
            {props.lang.inputs.relationship.fieldLabel}
          </InputLabel>
          <Select
            labelId="relationship-label"
            id="relationship"
            label={props.lang.inputs.relationship.fieldLabel}
            placeholder={props.lang.inputs.relationship.prompt}
            value={props.relationshipInputProps.value}
            onChange={e => {
              if (e.target.value)
                props.relationshipInputProps.onChange(
                  e.target.value as AccountRelationship
                );
            }}
            error={Boolean(props.relationshipInputProps.error)}
          >
            {props.relationshipInputProps.valueLabelMap.map(
              ([value, label]) => (
                <MenuItem key={value} value={value}>
                  {label}
                </MenuItem>
              )
            )}
          </Select>
          <FormHelperText color="error">
            {props.relationshipInputProps.error}
          </FormHelperText>
        </FormControl>

        <FormControl fullWidth>
          <InputLabel id="why-label">
            {props.lang.inputs.why.fieldLabel}
          </InputLabel>
          <Select
            labelId="why-label"
            id="why"
            label={props.lang.inputs.why.fieldLabel}
            placeholder={props.lang.inputs.why.prompt}
            value={props.whyInputProps.value}
            onChange={e => {
              if (e.target.value)
                props.whyInputProps.onChange(
                  e.target.value as RegistrationReason
                );
            }}
            error={Boolean(props.whyInputProps.error)}
          >
            {props.whyInputProps.valueLabelMap.map(([value, label]) => (
              <MenuItem key={value} value={value}>
                {label}
              </MenuItem>
            ))}
          </Select>
          <FormHelperText color="error">
            {props.whyInputProps.error}
          </FormHelperText>
        </FormControl>

        <Input
          value={props.commentsInputProps.value ?? ''}
          onChange={e => props.commentsInputProps.onChange(e.target.value)}
          onBlur={props.commentsInputProps.onBlur}
          error={props.commentsInputProps.error}
          label={props.lang.inputs.questionsOrComments.label}
          name="questionsOrComments"
          multiline
          rows={4}
        />
      </Box>
    </ProgressScreen>
  </form>
);
